import { useTranslation } from "react-i18next";
import React from "react";

import { NavbarMobileProps } from "./NavbarMobile.types";

import "./NavbarMobile.scss";
import BurgerSvg from './assets/images/burger.svg';
import CloseSvg from './assets/images/close.svg';
import NavbarLogo from './assets/images/logo.svg';

export const NavbarMobile: React.FC<NavbarMobileProps> = ({ userName, userAvatar, status, onPressBurger, onPressUser, onPressClose, isPressed=false }) => {
  const { t } = useTranslation();

  return(
    <div id={'mobile-nav'}>
      {
        !isPressed ?
      <div className={'user-info'}>
        <div className={'user'} onClick={()=> onPressUser ? onPressUser() : null}>
          <div className={'user-block'}>
            <span className={'user-name'}>
              {userName}
            </span>
            <div className={status}>
            { t(status) }
            </div>
          </div>
          <div className={'user-avatar'}>
            <img alt='avatar' src={userAvatar}/>
          </div>
        </div>
      </div>
         : <img alt='avatar' src={CloseSvg} onClick={()=> onPressClose ? onPressClose() : null}/>
         }
      <img className={'logo'} src={NavbarLogo} alt={ t("proxibit_tag_plain") }/>
      <div className={'burger-block'}>
        <button className={'burger-menu'} onClick={()=> onPressBurger ? onPressBurger() : null}>
          <img alt='menu' src={BurgerSvg}/>
        </button>
      </div>
    </div>
  )
};

